var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 7.14253V7.64253H10.4999V7.14253H9.49992ZM10.4999 7.13301V6.63301H9.49992V7.13301H10.4999ZM10.4999 13.333V9.52348H9.49992V13.333H10.4999ZM10.4999 7.14253V7.13301H9.49992V7.14253H10.4999ZM8.57135 10.4997H9.99992V9.49968H8.57135V10.4997ZM8.57135 13.3568H11.4285V12.3568H8.57135V13.3568ZM9.99992 3.83301C13.4057 3.83301 16.1666 6.59392 16.1666 9.99967H17.1666C17.1666 6.04163 13.958 2.83301 9.99992 2.83301V3.83301ZM3.83325 9.99967C3.83325 6.59392 6.59416 3.83301 9.99992 3.83301V2.83301C6.04188 2.83301 2.83325 6.04163 2.83325 9.99967L3.83325 9.99967ZM9.99992 16.1663C6.59416 16.1663 3.83325 13.4054 3.83325 9.99967L2.83325 9.99967C2.83325 13.9577 6.04188 17.1663 9.99992 17.1663L9.99992 16.1663ZM9.99992 17.1663C13.958 17.1663 17.1666 13.9577 17.1666 9.99967H16.1666C16.1666 13.4054 13.4057 16.1663 9.99992 16.1663L9.99992 17.1663Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.2e51e09a6bd11acdcb1ba5bedca2f2ec.svg";
export { ForwardRef as ReactComponent };